// AVTOMATIK YARATILGAN — qo'lda tahrirlamang: scripts/gen_module_columns.js (tog'a #1885, 2026-09-13)
// Manba: src/pages/**/data.tsx ustun ta'riflari; label = ru tarjimasi (jadval sarlavhasi bilan bir xil).
export const GENERATED_MODULE_COLUMNS: Record<string, { key: string; label: string }[]> = {
  "contracts": [
    {
      "key": "contractNumber",
      "label": "Номер договора"
    },
    {
      "key": "mainFactory",
      "label": "Завод"
    },
    {
      "key": "amountUSD",
      "label": "Сумма ($)"
    },
    {
      "key": "startDate",
      "label": "Начало"
    },
    {
      "key": "endDate",
      "label": "Окончание"
    },
    {
      "key": "purchasedUSD",
      "label": "Получено товара"
    },
    {
      "key": "remainingUSD",
      "label": "Осталось получить"
    },
    {
      "key": "paidUSD",
      "label": "Оплачено"
    },
    {
      "key": "unpaidUSD",
      "label": "Не оплачено"
    },
    {
      "key": "status",
      "label": "Статус"
    }
  ],
  "counterparties": [
    {
      "key": "name",
      "label": "Названия"
    },
    {
      "key": "isVerified",
      "label": "Проверка"
    },
    {
      "key": "lastname",
      "label": "Фамилия"
    },
    {
      "key": "middlename",
      "label": "Второе имя"
    },
    {
      "key": "phone",
      "label": "Телефон"
    },
    {
      "key": "email",
      "label": "Э-почта"
    },
    {
      "key": "address",
      "label": "Адрес"
    },
    {
      "key": "actions",
      "label": "Действия"
    },
    {
      "key": "saleProductDate",
      "label": "Дата продажи"
    },
    {
      "key": "saleProductNameModel",
      "label": "Имя модель"
    },
    {
      "key": "saleProductBarCode",
      "label": "Штрих-код"
    },
    {
      "key": "saleProductArticle",
      "label": "Артикул"
    },
    {
      "key": "saleBatchNumber",
      "label": "Партия"
    },
    {
      "key": "saleProductAmount",
      "label": "Количество"
    },
    {
      "key": "saleDebtUSD",
      "label": "Продажа USD"
    },
    {
      "key": "moneyAmountUSD",
      "label": "Сумма y.e"
    },
    {
      "key": "returnUSD",
      "label": "Возврат у.е"
    },
    {
      "key": "resultUSD",
      "label": "Остаток (+долг / −аванс)"
    }
  ],
  "customers": [
    {
      "key": "name",
      "label": "Названия"
    },
    {
      "key": "phone",
      "label": "Телефон"
    },
    {
      "key": "segment",
      "label": "Сегмент"
    },
    {
      "key": "totalPurchasedUSD",
      "label": "Всего покупок ($)"
    },
    {
      "key": "debtUSD",
      "label": "Долг"
    },
    {
      "key": "purchasesCount",
      "label": "Кол-во покупок"
    },
    {
      "key": "bonusBalance",
      "label": "Бонусный баланс"
    }
  ],
  "declarations": [
    {
      "key": "document",
      "label": "Документ закупки"
    },
    {
      "key": "dateDeclaration",
      "label": "Дата"
    },
    {
      "key": "declNumber",
      "label": "№ декларации"
    },
    {
      "key": "customsPost",
      "label": "Таможенный пост"
    },
    {
      "key": "comment",
      "label": "Комментарий"
    },
    {
      "key": "files",
      "label": "📎 Файлы"
    },
    {
      "key": "status",
      "label": "Статус"
    }
  ],
  "deliveries": [
    {
      "key": "deliveryNumber",
      "label": "№ Документа"
    },
    {
      "key": "mainCounterparty",
      "label": "Получатель"
    },
    {
      "key": "driverName",
      "label": "Водитель"
    },
    {
      "key": "driverPhone",
      "label": "Телефон водителя"
    },
    {
      "key": "vehicleInfo",
      "label": "Транспорт"
    },
    {
      "key": "route",
      "label": "Маршрут"
    },
    {
      "key": "inserted",
      "label": "Дата"
    },
    {
      "key": "shippedAt",
      "label": "Отправлено"
    },
    {
      "key": "confirmedAt",
      "label": "Доставлено"
    },
    {
      "key": "history",
      "label": "История"
    },
    {
      "key": "status",
      "label": "Статус"
    }
  ],
  "discountedProducts": [
    {
      "key": "nameModel",
      "label": "Имя модель"
    },
    {
      "key": "barCode",
      "label": "Штрих-код"
    },
    {
      "key": "article",
      "label": "Артикул"
    },
    {
      "key": "batchNumber",
      "label": "Партия"
    },
    {
      "key": "purchaseUSD",
      "label": "Закупка у.е"
    },
    {
      "key": "costPriceUSD",
      "label": "Себестоимость у.е"
    },
    {
      "key": "salePriceUSD",
      "label": "Цена продажи ($)"
    },
    {
      "key": "discount",
      "label": "Скидка %"
    },
    {
      "key": "discountBegin",
      "label": "Время начала"
    },
    {
      "key": "discountEnd",
      "label": "Время окончания"
    }
  ],
  "employees": [
    {
      "key": "firstName",
      "label": "Имя"
    },
    {
      "key": "position",
      "label": "Должность"
    },
    {
      "key": "department",
      "label": "Отдел"
    },
    {
      "key": "phone",
      "label": "Телефон"
    },
    {
      "key": "baseSalaryUSD",
      "label": "Базовый оклад ($)"
    },
    {
      "key": "status",
      "label": "Статус"
    }
  ],
  "factories": [
    {
      "key": "name",
      "label": "Названия"
    },
    {
      "key": "debt",
      "label": "Баланс / Долг"
    },
    {
      "key": "oldDebt",
      "label": "Старый долг"
    },
    {
      "key": "newDebt",
      "label": "Текущий долг"
    },
    {
      "key": "phone",
      "label": "Телефон"
    },
    {
      "key": "email",
      "label": "Э-почта"
    },
    {
      "key": "address",
      "label": "Адрес"
    },
    {
      "key": "inserted",
      "label": "Вставлен"
    }
  ],
  "factoryPurchases": [
    {
      "key": "datePurchase",
      "label": "Дата закупки"
    },
    {
      "key": "document",
      "label": "Документа"
    },
    {
      "key": "status",
      "label": "Статус"
    },
    {
      "key": "mainProduct",
      "label": "Товар"
    },
    {
      "key": "mainProduct:штрих_код",
      "label": "Штрих-код"
    },
    {
      "key": "mainProduct:артикул",
      "label": "Артикул"
    },
    {
      "key": "mainProduct:партия",
      "label": "Партия"
    },
    {
      "key": "mainWarehouse",
      "label": "Склад"
    },
    {
      "key": "mainFactory",
      "label": "Завод"
    },
    {
      "key": "mainUsers",
      "label": "Автор"
    },
    {
      "key": "amount",
      "label": "Кол-во"
    },
    {
      "key": "totalPriceUSD",
      "label": "Сумма y.e"
    },
    {
      "key": "document:коды",
      "label": "Коды"
    }
  ],
  "managers": [
    {
      "key": "name",
      "label": "Названия"
    },
    {
      "key": "lastname",
      "label": "Фамилия"
    },
    {
      "key": "phone",
      "label": "Телефон"
    },
    {
      "key": "email",
      "label": "Э-почта"
    },
    {
      "key": "permission",
      "label": "Разделы"
    }
  ],
  "moneys": [
    {
      "key": "dateMoney",
      "label": "Дата"
    },
    {
      "key": "document",
      "label": "Документа"
    },
    {
      "key": "mainWarehouse",
      "label": "Склад"
    },
    {
      "key": "receivedUserName",
      "label": "Принял"
    },
    {
      "key": "mainCounterparty",
      "label": "Контрагент"
    },
    {
      "key": "payForDocs",
      "label": "За что"
    },
    {
      "key": "mainFactory",
      "label": "Завод"
    },
    {
      "key": "moneyPurposePayment",
      "label": "Цель"
    },
    {
      "key": "amountUSD",
      "label": "Сумма y.e"
    },
    {
      "key": "debtAfterUSD",
      "label": "Долг после"
    },
    {
      "key": "exchangeRate",
      "label": "Обменный курс"
    },
    {
      "key": "moneyPaymentType",
      "label": "Способ оплаты"
    },
    {
      "key": "reason",
      "label": "Причина"
    },
    {
      "key": "attachment",
      "label": "Файл"
    },
    {
      "key": "status",
      "label": "Статус"
    },
    {
      "key": "mainUsers",
      "label": "Автор"
    },
    {
      "key": "type",
      "label": "Доход / расход"
    },
    {
      "key": "allocate",
      "label": "Закупка"
    }
  ],
  "orders": [
    {
      "key": "document",
      "label": "Документа"
    },
    {
      "key": "dateOrder",
      "label": "Дата заказа"
    },
    {
      "key": "amount",
      "label": "Количество"
    },
    {
      "key": "mainCounterparty",
      "label": "Контрагент"
    },
    {
      "key": "mainProduct",
      "label": "Товар"
    },
    {
      "key": "mainProduct:штрих_код",
      "label": "Штрих-код"
    },
    {
      "key": "mainProduct:артикул",
      "label": "Артикул"
    },
    {
      "key": "mainProduct:партия",
      "label": "Партия"
    },
    {
      "key": "status",
      "label": "Статус"
    },
    {
      "key": "dateOrder:ожидание",
      "label": "Ожидание"
    },
    {
      "key": "rejectReason",
      "label": "Причина"
    },
    {
      "key": "actions",
      "label": "Действия"
    }
  ],
  "products": [
    {
      "key": "nameModel",
      "label": "Имя модель"
    },
    {
      "key": "barCode",
      "label": "Штрих-код"
    },
    {
      "key": "article",
      "label": "Артикул"
    },
    {
      "key": "batchNumber",
      "label": "Номер партии"
    },
    {
      "key": "productType",
      "label": "Тип продукта"
    },
    {
      "key": "productCategory",
      "label": "Категория продукта"
    },
    {
      "key": "productUnit",
      "label": "Единица измерения"
    },
    {
      "key": "costPriceUSD",
      "label": "Себестоимость у.е"
    },
    {
      "key": "salePriceUSD",
      "label": "Цена продажи ($)"
    },
    {
      "key": "wholesalePriceUSD",
      "label": "Оптовая цена ($)"
    },
    {
      "key": "id",
      "label": "Менеджерам"
    },
    {
      "key": "productCount",
      "label": "Количество"
    },
    {
      "key": "discount",
      "label": "Скидка %"
    },
    {
      "key": "photo",
      "label": "Фото"
    }
  ],
  "purchases": [
    {
      "key": "datePurchase",
      "label": "Дата закупки"
    },
    {
      "key": "document",
      "label": "Документа"
    },
    {
      "key": "status",
      "label": "Статус"
    },
    {
      "key": "mainProduct",
      "label": "Товар"
    },
    {
      "key": "mainProduct:штрих_код",
      "label": "Штрих-код"
    },
    {
      "key": "mainProduct:артикул",
      "label": "Артикул"
    },
    {
      "key": "batchNumber",
      "label": "Партия"
    },
    {
      "key": "productType",
      "label": "Тип продукта"
    },
    {
      "key": "mainWarehouse",
      "label": "Склад"
    },
    {
      "key": "mainUsers",
      "label": "Автор"
    },
    {
      "key": "amount",
      "label": "Кол-во"
    },
    {
      "key": "priceUSD",
      "label": "Цена закупки ($)"
    },
    {
      "key": "landedPriceUSD",
      "label": "Себестоимость ед. ($)"
    },
    {
      "key": "wholesalePriceUSD",
      "label": "Оптовая цена ($)"
    },
    {
      "key": "retailPriceUSD",
      "label": "Розничная цена ($)"
    },
    {
      "key": "totalPriceUSD",
      "label": "Сумма y.e"
    },
    {
      "key": "expenseUSD",
      "label": "Расход · метод"
    }
  ],
  "reports": [
    {
      "key": "counterpartyId",
      "label": "Контрагент ID"
    },
    {
      "key": "counterpartyName",
      "label": "Название контрагента"
    },
    {
      "key": "counterpartyEmail",
      "label": "Почта контрагента"
    },
    {
      "key": "counterpartyPhone",
      "label": "Телефон контрагента"
    },
    {
      "key": "comingUSD",
      "label": "Прибытие USD"
    },
    {
      "key": "receiptAmountUSD",
      "label": "Сумма квитанции USD"
    },
    {
      "key": "debtUSD",
      "label": "Долг USD"
    },
    {
      "key": "returnSaleUSD",
      "label": "Возвращенная сумма"
    },
    {
      "key": "returnSaleCount",
      "label": "Количество возвратов"
    },
    {
      "key": "nameReport",
      "label": "Названия"
    },
    {
      "key": "yan",
      "label": "Январь"
    },
    {
      "key": "fev",
      "label": "Февраль"
    },
    {
      "key": "mar",
      "label": "Март"
    },
    {
      "key": "apr",
      "label": "Апрель"
    },
    {
      "key": "may",
      "label": "Май"
    },
    {
      "key": "iyn",
      "label": "Июнь"
    },
    {
      "key": "iyl",
      "label": "Июль"
    },
    {
      "key": "aug",
      "label": "Август"
    },
    {
      "key": "sen",
      "label": "Сентябрь"
    },
    {
      "key": "okt",
      "label": "Октябрь "
    },
    {
      "key": "noy",
      "label": "Ноябрь"
    },
    {
      "key": "dek",
      "label": "Декабрь"
    },
    {
      "key": "type",
      "label": "Доход / расход"
    },
    {
      "key": "productId",
      "label": "Продукт ID"
    },
    {
      "key": "productName",
      "label": "Наименование товара"
    },
    {
      "key": "productBarCode",
      "label": "Штрих-код"
    },
    {
      "key": "productArticle",
      "label": "Артикул"
    },
    {
      "key": "revenue",
      "label": "Выручка"
    },
    {
      "key": "profit",
      "label": "Прибыль"
    },
    {
      "key": "costSaleUSD",
      "label": "Себестоимость продаж"
    },
    {
      "key": "saleCount",
      "label": "Закуплено (за период)"
    },
    {
      "key": "soldCount",
      "label": "Продано"
    },
    {
      "key": "defectiveCount",
      "label": "Брак"
    }
  ],
  "residues": [
    {
      "key": "productName",
      "label": "Названия"
    },
    {
      "key": "storagePlace",
      "label": "Место"
    },
    {
      "key": "barCode",
      "label": "Штрих-код"
    },
    {
      "key": "article",
      "label": "Артикул"
    },
    {
      "key": "batches",
      "label": "Партия"
    },
    {
      "key": "lastPurchaseDocument",
      "label": "Последний документ закупки"
    },
    {
      "key": "purchaseUSD",
      "label": "Закупка у.е"
    },
    {
      "key": "saleUSD",
      "label": "Последняя продажа ($)"
    },
    {
      "key": "salePriceUSD",
      "label": "Цена продажи ($)"
    },
    {
      "key": "wholesalePriceUSD",
      "label": "Оптовая цена ($)"
    },
    {
      "key": "costPriceUSD",
      "label": "Себестоимость у.е"
    },
    {
      "key": "totalPriceUSD",
      "label": "Общая цена USD"
    },
    {
      "key": "totalCount",
      "label": "Общее количество"
    },
    {
      "key": "reservedCount",
      "label": "Забронировано"
    },
    {
      "key": "inTransitCount",
      "label": "В пути"
    },
    {
      "key": "defectCount",
      "label": "Брак"
    },
    {
      "key": "showcaseCount",
      "label": "Количество витрины"
    }
  ],
  "returnPurchases": [
    {
      "key": "dateReturnPurchase",
      "label": "Дата Возврат закупки"
    },
    {
      "key": "document",
      "label": "Документа"
    },
    {
      "key": "isDefective",
      "label": "Брак"
    },
    {
      "key": "mainPurchase",
      "label": "Дата закупки"
    },
    {
      "key": "mainPurchase:склад",
      "label": "Склад"
    },
    {
      "key": "mainPurchase:товар",
      "label": "Товар"
    },
    {
      "key": "mainPurchase:штрих_код",
      "label": "Штрих-код"
    },
    {
      "key": "mainPurchase:артикул",
      "label": "Артикул"
    },
    {
      "key": "batchNumber",
      "label": "Партия"
    },
    {
      "key": "amount",
      "label": "Кол-во"
    },
    {
      "key": "priceUSD",
      "label": "Сумма y.e"
    }
  ],
  "returnSales": [
    {
      "key": "dateReturnSale",
      "label": "Дата возврата продажи"
    },
    {
      "key": "document",
      "label": "Документа"
    },
    {
      "key": "status",
      "label": "Статус"
    },
    {
      "key": "mainWarehouse",
      "label": "Склад"
    },
    {
      "key": "mainUsers",
      "label": "Автор"
    },
    {
      "key": "mainCounterparty",
      "label": "Контрагент"
    },
    {
      "key": "mainProduct",
      "label": "Товар"
    },
    {
      "key": "mainProduct:штрих_код",
      "label": "Штрих-код"
    },
    {
      "key": "mainProduct:артикул",
      "label": "Артикул"
    },
    {
      "key": "batchNumber",
      "label": "Партия"
    },
    {
      "key": "amount",
      "label": "Кол-во"
    },
    {
      "key": "priceUSD",
      "label": "Сумма y.e"
    },
    {
      "key": "photo",
      "label": "Фото"
    },
    {
      "key": "defectActions",
      "label": "Брак: остаток и действия"
    }
  ],
  "sales": [
    {
      "key": "dateSale",
      "label": "Дата продажи"
    },
    {
      "key": "document",
      "label": "Документа"
    },
    {
      "key": "status",
      "label": "Статус"
    },
    {
      "key": "mainUsers",
      "label": "Автор"
    },
    {
      "key": "mainWarehouse",
      "label": "Склад"
    },
    {
      "key": "mainProduct",
      "label": "Товар"
    },
    {
      "key": "mainProduct:штрих_код",
      "label": "Штрих-код"
    },
    {
      "key": "mainProduct:артикул",
      "label": "Артикул"
    },
    {
      "key": "batchNumber",
      "label": "Партия"
    },
    {
      "key": "amount",
      "label": "Кол-во"
    },
    {
      "key": "priceUSD",
      "label": "Цена y.e"
    },
    {
      "key": "totalPriceUSD",
      "label": "Сумма y.e"
    },
    {
      "key": "discount",
      "label": "Скидка %"
    },
    {
      "key": "bonusUSD",
      "label": "Бонус"
    },
    {
      "key": "autoPriceUSD",
      "label": "Цена по каталогу"
    },
    {
      "key": "priceChanged",
      "label": "Цена изменена"
    }
  ],
  "shops": [
    {
      "key": "counterpartyName",
      "label": "Владелец (контрагент)"
    },
    {
      "key": "subscriptionUntil",
      "label": "Срок (до)"
    },
    {
      "key": "name",
      "label": "Названия"
    },
    {
      "key": "debtUSD",
      "label": "Долг"
    },
    {
      "key": "linkedVerified",
      "label": "Проверка"
    },
    {
      "key": "address",
      "label": "Адрес"
    },
    {
      "key": "phone",
      "label": "Телефон"
    },
    {
      "key": "mainWarehouse",
      "label": "Склад"
    },
    {
      "key": "status",
      "label": "Статус"
    },
    {
      "key": "actions",
      "label": "Действия"
    }
  ],
  "showcases": [
    {
      "key": "sellerConfirm",
      "label": "Статус"
    },
    {
      "key": "count",
      "label": "Количество"
    },
    {
      "key": "inserted",
      "label": "Дата"
    },
    {
      "key": "mainCounterparty",
      "label": "Контрагент"
    },
    {
      "key": "mainCounterparty:почта_контрагента",
      "label": "Почта контрагента"
    },
    {
      "key": "mainCounterparty:телефон",
      "label": "Телефон"
    },
    {
      "key": "mainCounterparty:адрес",
      "label": "Адрес"
    },
    {
      "key": "действия",
      "label": "Действия"
    },
    {
      "key": "mainProduct",
      "label": "Фото"
    },
    {
      "key": "mainProduct:имя_модель",
      "label": "Имя модель"
    },
    {
      "key": "mainProduct:штрих_код",
      "label": "Штрих-код"
    },
    {
      "key": "mainProduct:артикул",
      "label": "Артикул"
    },
    {
      "key": "mainProduct:партия",
      "label": "Партия"
    }
  ],
  "transfers": [
    {
      "key": "inserted",
      "label": "Дата перевода"
    },
    {
      "key": "transferNumber",
      "label": "Документа"
    },
    {
      "key": "mainUsers",
      "label": "Автор"
    },
    {
      "key": "mainProduct",
      "label": "Товар"
    },
    {
      "key": "mainProduct:штрих_код",
      "label": "Штрих-код"
    },
    {
      "key": "mainProduct:артикул",
      "label": "Артикул"
    },
    {
      "key": "batchNumber",
      "label": "Номер партии"
    },
    {
      "key": "oldWarehouseName",
      "label": "Старое название склада"
    },
    {
      "key": "newWarehouseName",
      "label": "Новое название склада"
    },
    {
      "key": "transferCount",
      "label": "Количество переводов"
    },
    {
      "key": "salePriceUSD",
      "label": "Цена продажи"
    },
    {
      "key": "transferPriceUSD",
      "label": "Цена перевода"
    },
    {
      "key": "transferSumUSD",
      "label": "Сумма перевода"
    },
    {
      "key": "status",
      "label": "Статус"
    },
    {
      "key": "transfersCount",
      "label": "Кол-во перемещений"
    },
    {
      "key": "totalAmount",
      "label": "Общее количество (шт)"
    },
    {
      "key": "pendingCount",
      "label": "Статусы"
    },
    {
      "key": "date",
      "label": "Дата"
    },
    {
      "key": "fromWarehouse",
      "label": "Откуда (Склад)"
    },
    {
      "key": "toWarehouse",
      "label": "Куда (Склад)"
    },
    {
      "key": "sent",
      "label": "Отправлено"
    },
    {
      "key": "accepted",
      "label": "Принято"
    },
    {
      "key": "shortage",
      "label": "Недостача"
    },
    {
      "key": "sentBy",
      "label": "Кто отправил"
    },
    {
      "key": "acceptedBy",
      "label": "Кто принял"
    }
  ],
  "warehouses": [
    {
      "key": "name",
      "label": "Названия"
    },
    {
      "key": "selected",
      "label": "Основной склад"
    },
    {
      "key": "address",
      "label": "Адрес"
    },
    {
      "key": "status",
      "label": "Статус"
    },
    {
      "key": "storageRows",
      "label": "Места хранения"
    },
    {
      "key": "inserted",
      "label": "Вставлен"
    },
    {
      "key": "updated",
      "label": "Обновлён"
    }
  ]
}
